import { createFileRoute } from '@tanstack/react-router';

import { CountPage } from '../../../modules/inventory/counts/count-page.js';
import { parseCountRouteSearch } from '../../../modules/inventory/counts/count-route-search.js';

export const Route = createFileRoute('/inventory/counts/new')({
  validateSearch: parseCountRouteSearch,
  component: NewCountRoute,
});

// eslint-disable-next-line react-refresh/only-export-components -- route files export both Route and their page component; fast refresh flags the second export
function NewCountRoute() {
  return <CountPage search={Route.useSearch()} />;
}
